(() => {
  // app/scripts/common/popup.js
  var Popup = class {
    constructor(container) {
      this.container = container;
      this.dataControl = this.container.dataset.control;
      this.bodyClass = ["popup-show", "overflow-hidden"];
      this.elems = {
        close: this.container.querySelectorAll(".js-popup-close")
      };
      this.eventListener();
    }
    toggle(bool) {
      this.container.classList.toggle("active", bool);
      if (bool)
        document.body.classList.add(...this.bodyClass);
      else
        document.body.classList.remove(...this.bodyClass);
      document.querySelectorAll(`.js-popup-toggle[data-control="${this.dataControl}"]`)?.forEach((el) => el.classList.toggle("active", bool));
    }
    eventListener() {
      this.elems.close?.forEach((item) => {
        item.addEventListener("click", (e) => {
          e.preventDefault();
          this.toggle(false);
        });
      });
    }
  };
  var popup_default = Popup;

  // node_modules/@shopify/theme-currency/currency.js
  var moneyFormat = "${{amount}}";
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  // app/scripts/common/add-on-component.js
  window.customElements.define("addon-component", class extends HTMLElement {
    constructor() {
      super();
      this.defaultPrice = +document.querySelector(".jsPriceDefault").dataset.price;
      this.addEventListener("change", this._onChange.bind(this));
    }
    _onChange(event) {
      this.updateTotalPrice();
      document.querySelector('[name=id][form="mainForm"]').value = event.target.value;
    }
    updateTotalPrice() {
      const totalPrice = this.getItemChecked.reduce((sum, item) => sum + +item.dataset.price, 0);
      document.querySelector(".jsPriceDefault").innerHTML = formatMoney(totalPrice, theme.currency.moneyFormat_strip);
    }
    get getItemChecked() {
      return [...this.querySelectorAll("input:checked")];
    }
    submit() {
      const items = [];
      return new Promise((resolve, reject) => {
        this.getItemChecked.forEach((input) => {
          items.push({
            id: input.value
          });
        });
        if (!items.length) {
          resolve(true);
          return;
        }
        fetch(window.theme.routes.cartAdd, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items })
        }).then((result) => {
          console.log(result);
          resolve(true);
        });
      });
    }
  });

  // app/scripts/product-custom-tray.js
  var fieldCreate = class extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector("input");
      this.template = this.querySelector("template");
      this.container = this.querySelector(".js-fields");
      this.querySelector("button")?.addEventListener("click", this.createField.bind(this));
    }
    createField() {
      this.container.innerHTML = "";
      if (this.input.value < 1)
        return;
      let i = 0;
      do {
        i++;
        let html = this.template.content.firstElementChild.cloneNode(true);
        this.container.insertAdjacentHTML("beforeend", html.innerHTML.replaceAll("(index)", this.ordinal(i)));
      } while (i < this.input.value);
    }
    ordinal(value) {
      if (value == 1) {
        return "1st";
      } else if (value == 2) {
        return "2nd";
      } else if (value == 3) {
        return "3rd";
      } else {
        return value + "th";
      }
    }
  };
  customElements.define("field-created", fieldCreate);
  var toggleProperties = class extends HTMLElement {
    constructor() {
      super();
      this.toggle(this.getBoundingClientRect().width > 0, true);
      const observer = new MutationObserver((mutationList, observer2) => {
        mutationList.forEach((mutation) => {
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            this.toggle(this.getBoundingClientRect().width > 0);
          }
        });
      });
      observer.observe(this, {
        attributes: true
      });
    }
    toggle(showing, init) {
      this.querySelectorAll('[name^="properties"], [data-name^="properties"]')?.forEach((i) => {
        init && i.setAttribute("data-name", i.name);
        i.name = showing ? i.dataset.name : "";
        i.toggleAttribute("required", showing);
      });
    }
  };
  customElements.define("toggle-properties", toggleProperties);
  document.querySelectorAll(".js-toggle-properties")?.forEach((i) => {
    i.addEventListener("change", (e) => {
      if (i.name == "Question1") {
        document.querySelector("#measurementButton")?.classList.toggle("hidden", i.dataset.value == "no");
      }
      if (i.name == "Question2") {
        document.querySelector("#trayRack")?.classList.toggle("hidden", i.dataset.value == "no");
      }
    });
  });
  document.querySelector(".js-form-submit")?.addEventListener("submit", async (e) => {
    const value = document.querySelector(".js-thick-condition")?.value || 0;
    const radioRequired = document.querySelectorAll(".js-radio-required");
    const radioUncheck = document.querySelectorAll(".js-radio-required:not(:checked)");
    let valid = true;
    if (value < 10 || value > 50) {
      e.preventDefault();
      e.stopPropagation();
      const popup = document.querySelector(".js-thick-popup");
      popup && new popup_default(popup).toggle();
      valid = false;
    } else if (radioRequired.length && radioRequired.length == radioUncheck.length) {
      e.preventDefault();
      e.stopPropagation();
      const popup = document.querySelector(".js-question-popup");
      popup && new popup_default(popup).toggle();
      valid = false;
    }
    if (valid && document.querySelector("addon-component")) {
      e.target.closest("form").submit();
    }
  });
})();
